var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('v-app-bar',{attrs:{"color":"deep-purple","dark":"","short":"","app":""}},[_c('v-spacer'),_c('v-btn',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }